export default "__VITE_ASSET__f8665898__"